import './alpine';

import jQuery from 'jquery';
import blazor from "./blazor";
import chatFiles from "./chat/chatFiles.js";
import chatStream from "./chat/chatStream.js";
import flowbite from "./flowbite";
import intersectionObservers from './intersection-observers/index.js';
import keybinds from './keybinds/index.js';
import logRocket from "./chat/logRocket.js";
import ricApi from "./chat/ricApi.js";
import quill from './quill/index.js';
import sortable from './sortable/index.js';
import utilities from './utilities/index.js';

window.$ = jQuery;
window.jQuery = jQuery;

window.ra = window.ra || {};
window.ra.blazor = blazor;
window.ra.chatFiles = chatFiles;
window.ra.chatStream = chatStream;
window.ra.flowbite = flowbite;
window.ra.intersectionObservers = intersectionObservers;
window.ra.keybinds = keybinds;
window.ra.logRocket = logRocket;
window.ra.ricApi = ricApi;
window.ra.quill = quill;
window.ra.sortable = sortable;
window.ra.utilities = utilities;

/*
window.riskaliveOverrides = {
    hermesEnvironment: 'UAT',
    phoenixEnvironment: 'UAT',
    loraxEnvironment: 'UAT',
    osirisEnvironment: 'UAT',
};
*/
/*
window.riskaliveOverrides = {
    hermesEnvironment: 'Local',
    chatApiUrl: 'https://localhost:38032',
};
*/

const script = document.createElement('script');
const hostname = window.location.hostname.toLowerCase();
if (hostname == 'localhost' || hostname == '127.0.0.1' || hostname.endsWith('-local.riskalive.com') || hostname.endsWith('-dev.riskalive.com')) {
    script.setAttribute('src', 'https://lorax-dev.riskalive.com/riskalive.js');
} else if (hostname.endsWith('-uat.riskalive.com')) {
    script.setAttribute('src', 'https://lorax-uat.riskalive.com/riskalive.js');
} else if (hostname.endsWith('-staging.riskalive.com')) {
    script.setAttribute('src', 'https://lorax-staging.riskalive.com/riskalive.js');
} else {
    script.setAttribute('src', 'https://lorax.riskalive.com/riskalive.js');
}

document.head.appendChild(script);

const startBlazor = function () {
    setTimeout(function () {
        if (!window.riskalive) {
            console.log('Waiting for riskalive.js script.');
            startBlazor();
            return;
        }

        Blazor.start();
    }, 50);
};

startBlazor();

setTimeout(function () {
    if (document.querySelector('.initial-loader')) {
        document.querySelector('.initial-loader-content').style.display = "none";
        document.getElementById('app_failed').style.display = "block";
    }
}, 20000);
